import React from 'react';
import { Slider } from 'antd';

function CustomSlider({ state, setState, min, max, marks, step }) {
  const onSliderChange = (value) => {
    setState(value);
  };

  return <Slider dots min={min} max={max} marks={marks} value={state} step={step} onChange={onSliderChange} />;
}

export default CustomSlider;
